import { render } from "./DaftarAmpunHasil.vue?vue&type=template&id=19933b31"
import script from "./DaftarAmpunHasil.vue?vue&type=script&lang=js"
export * from "./DaftarAmpunHasil.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__